export default "__VITE_ASSET__DPLjjmjg__"